export default __webpack_public_path__ + "static/media/cloud_dedicado.aee330bf.svg";